import { CSSProperties, ReactNode, useEffect } from 'react'
import cn from 'classnames'

import './styles.scss'

interface ModalProps {
  open: boolean
  onClose: () => void
  title?: ReactNode
  style?: CSSProperties
  className?: string
  children: ReactNode
}

export const BaseModal = ({ open, onClose, title, style, className, children }: ModalProps) => {
  useEffect(() => {
    const onEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    if (open) {
      document.addEventListener('keydown', onEscape)
      document.body.style.overflow = 'hidden'
    } else {
      document.removeEventListener('keydown', onEscape)
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.removeEventListener('keydown', onEscape)
      document.body.style.overflow = 'unset'
    }
  }, [open, onClose])

  const onOverlayClick = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      onClose()
    }
  }

  if (!open) return null

  return (
    <div className={cn('modal-overlay', className)} style={style} onClick={onOverlayClick}>
      <div className="modal">
        {title && <div className="modal-title">{title}</div>}
        <button className="modal-close" onClick={onClose} aria-label="Закрыть модальное окно">
          &times;
        </button>

        <div className="modal-content">{children}</div>
      </div>
    </div>
  )
}
